import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";

const navigationHistory = [];

export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    navigationHistory.push(location.pathname);
  }, [location]);

  const handleClick = () => {
    if (navigationHistory.length > 1) {
      navigationHistory.pop();
      const previousRoute = navigationHistory[navigationHistory.length - 1];
      navigate(previousRoute);
    } else {
      
      console.log("No valid internal history to navigate back to");
    }
  };

  return (
    <button onClick={() => navigate(-1)}>
      <ArrowLeftIcon width={"1.5rem"} height={"1.5rem"} />
    </button>
  );
};
